<progress
  *ngIf="goal > 0"
  class="loyalty-progress"
  [value]="balance"
  [max]="goal"
></progress>
